module.exports = __webpack_public_path__ + "static/media/landingCollaborator7.3328089b.jpg";